import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { createWorkflowStage } from '../index';
export const useCreateWorkflowStage = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(createWorkflowStage, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetStagesDescription');
            setAction({
                type: 'success',
                message: 'Creation of the workflow stage was successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
